/* eslint-disable react/jsx-pascal-case */
import React, { Component } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  // Form,
  FormGroup,
  Label,
  // Input,
  Col,
  // FormFeedback,
  Row,
  Input,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, Form, Errors, actions } from 'react-redux-form';
import { checkHtmlTagAutoComplete } from '../utils/htmlTagAutoComplete';
import { handleArithmeticInput } from '../utils/arithmeticEval';
import { selectImageTagOnDoubleClick } from '../utils/imagePasteResize';

class Kirk extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (value, event) => {
    this.props.postKirk(
      value.date,
      value.place,
      value.person,
      value.subject,
      value.reason,
      value.how,
      value.data,
      value.work,
      value.news,
      value.buy,
      value.utilities,
      value.events,
      value.health,
      value.foods,
      value.invests
    );
    // alert('Current State is: ' + JSON.stringify(values));
    // this.props.resetKirkForm();
    // e.preventDefault();
  };

  // Handle HTML tag auto-completion for textarea fields
  handleTagAutoComplete = (e) => {
    const textarea = e.target;
    const value = textarea.value;
    const cursorPos = textarea.selectionStart;

    // Check for arithmetic evaluation (e.g. "1+1=" -> "2")
    handleArithmeticInput(textarea, value, (newVal) => {
      textarea.value = newVal;
      const inputEvent = new Event('input', { bubbles: true });
      textarea.dispatchEvent(inputEvent);
    });

    // Check for auto-completion
    const result = checkHtmlTagAutoComplete(value, cursorPos);
    if (result) {
      // Update the textarea value directly
      textarea.value = result.newValue;
      // Trigger change event for react-redux-form
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
      // Set cursor position
      setTimeout(() => {
        textarea.selectionStart = result.cursorPos;
        textarea.selectionEnd = result.cursorPos;
        textarea.focus();
      }, 0);
    }
  };

  render() {
    return (
      <div className="container main">
        {/* <div className="row row-content"> */}
        {/* <div className="col-12"> */}
        <div className="mb-2">
          <h1>
            <b>Kirk</b>
          </h1>
        </div>
        {/* <div className="col-12 col-md-9"> */}
        <p>
          Take all your Kirks and look them back sometimes. You will find
          something good.
        </p>
        <Form
          model="kirk"
          onSubmit={(value, event) => this.handleSubmit(value, event)}
          // onSubmit={this.handleSubmit}
        >
          {/*  this FormGroup row allows us to use bootstrap's grid inside the form to lay out the various form elements.  */}
          <Row className="form-group mb-2">
            <Label htmlFor="date" md={2}>
              date
            </Label>
            <Col md={10}>
              <Control.text
                model=".date"
                id="date"
                name="date"
                placeholder="when? If NULL, Kirk autofills"
                className="form-control"
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="place" md={2}>
              place
            </Label>
            <Col md={10}>
              <Control.text
                model=".place"
                id="place"
                name="place"
                placeholder="where?"
                className="form-control"
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="person" md={2}>
              person
            </Label>
            <Col md={10}>
              <Control.text
                model=".person"
                id="person"
                name="person"
                placeholder="who?"
                className="form-control"
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="subject" md={2}>
              subject
            </Label>
            <Col md={10}>
              <Control.text
                model=".subject"
                id="subject"
                name="subject"
                placeholder="what?"
                className="form-control"
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="reason" md={2}>
              reason
            </Label>
            <Col md={10}>
              <Control.textarea
                model=".reason"
                id="reason"
                name="reason"
                placeholder="why?"
                className="form-control"
                onChange={this.handleTagAutoComplete}
                onDoubleClick={selectImageTagOnDoubleClick}
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="how" md={2}>
              how
            </Label>
            <Col md={10}>
              <Control.textarea
                model=".how"
                id="how"
                name="how"
                placeholder="how?"
                className="form-control"
                onChange={this.handleTagAutoComplete}
                onDoubleClick={selectImageTagOnDoubleClick}
              />
            </Col>
          </Row>
          <Row className="form-group mb-2">
            <Label htmlFor="data" md={2}>
              data
            </Label>
            <Col md={10}>
              <Control.text
                model=".data"
                id="data"
                name="data"
                placeholder="data?"
                className="form-control"
              />
            </Col>
          </Row>

          <Row className="form-group mt-5">
            {/* <Col> */}
            <Button
              type="submit"
              color="secondary"
              disabled={this.props.isUpdating} // 2023.11.18
            >
              {' '}
              Submit
            </Button>
            {/* </Col> */}
          </Row>
        </Form>
        {/* </div> */}
      </div>
      // </div>
    );
  }
}

export default Kirk;
